import classNames from 'classnames';
import Chip, { ChipProps } from '@/components/molecules/chip/chip';
import styles from './companions-chip-list.module.scss';

export interface CompanionChip extends ChipProps {
  id: string;
}

export interface CompanionsChipListProps<T extends CompanionChip> {
  /** The class name to apply */
  className?: string;
  /** An array of companion chips to show */
  items: T[];
  /** An event that is triggered on clicking a companion chip */
  onClickChip?: (item: T) => void;
  /** An event that is triggered on removing a companion chip */
  onClickRemoveChip?: (item: T) => void;
}

const CompanionsChipList = <T extends CompanionChip>({
  className,
  items = [],
  onClickChip,
  onClickRemoveChip,
}: CompanionsChipListProps<T>) => {
  if (items.length === 0) return null;

  return (
    <div className={classNames(styles.component, className)}>
      {items.map(item => (
        <Chip
          key={item.id}
          isSelected={item.isSelected}
          label={item.label}
          onClick={onClickChip ? () => onClickChip(item) : undefined}
          onClickClose={
            item.isSelected && onClickRemoveChip
              ? () => onClickRemoveChip(item)
              : undefined
          }
        />
      ))}
    </div>
  );
};

CompanionsChipList.displayName = 'CompanionsChipList';

export default CompanionsChipList;
